import { ACCEPTED_UPLOAD_MIME_TYPES } from './uploadMimeTypes';

const ACCEPTED_UPLOAD_MIME_TYPES_STRING = ACCEPTED_UPLOAD_MIME_TYPES.join(',');

/**
 * Opens a native file picker for canvas-uploadable media and hands the selection to `onFiles`.
 *
 * The input is created dynamically and appended to document.body because rendering it inside
 * ReactFlow's `<Panel>` swallows events, and browsers require the element to be in the DOM for
 * onchange to fire.
 */
export const pickUploadFiles = (onFiles: (files: File[]) => void) => {
  const input = document.createElement('input');
  input.type = 'file';
  input.multiple = true;
  input.accept = ACCEPTED_UPLOAD_MIME_TYPES_STRING;
  input.style.display = 'none';

  const removeInput = () => document.body.contains(input) && document.body.removeChild(input);

  input.onchange = () => {
    const files = input.files;

    if (files && files.length > 0) {
      onFiles(Array.from(files));
    }
    removeInput();
  };

  input.addEventListener('cancel', removeInput);

  document.body.appendChild(input);
  input.click();
};
